import { useDisclosure } from '@ds';
import { ConditionalRender } from '@ui';
import { PropsWithChildren } from 'react';
import { LogTypeKeys } from '@features/components/ClinicalData/components/ClinicalLog/types';
import { RadiometerLabelSize } from '@features/components/ClinicalData/components/ClinicalLog/components/constants';
import { useAppContext } from '@features/contexts/AppProvider';
import { LogItemHeader } from './LogItemHeader';
import { LogItemLayout } from './LogItemLayout';
import { ClinicalDataNameValue } from '../LogItems/types';
import { MeasurementRow } from './MeasurementRow';

type RadiometerLayoutProps = {
  event: string;
  measurements: ClinicalDataNameValue[];
  onShareClick?: () => void;
  shared?: boolean;
} & PropsWithChildren;

const cssStyles = {
  [RadiometerLabelSize.minor]: {
    labelClassNames: 'text-s-m',
  },
  [RadiometerLabelSize.base]: {
    labelClassNames: 'font-medium',
  },
};

export const RadiometerLayout = ({ event, measurements, children, onShareClick, shared }: RadiometerLayoutProps) => {
  const { isOpen, onOpenChange } = useDisclosure();
  const {
    clinicalLog: { styles },
  } = useAppContext();
  const style = cssStyles[styles[LogTypeKeys.RadiometerLayout] as RadiometerLabelSize];

  return (
    <LogItemLayout>
      <div className="w-full flex flex-col gap-2">
        <LogItemHeader
          onShareClick={onShareClick}
          event={event}
          cssStyleBySize={style}
          onOpenChange={onOpenChange}
          isOpen={isOpen}
          sharedIndicatorIcon={shared}
        />
        <div className="flex flex-col gap-1">
          {measurements.map(({ name, value }) => (
            <MeasurementRow label={name} value={value} key={name} />
          ))}
        </div>
        <ConditionalRender show={isOpen}>{children}</ConditionalRender>
      </div>
    </LogItemLayout>
  );
};
